module.exports = __webpack_public_path__ + "img/pethouse35.57bad72d.jpg";